import { CMSResource } from "app/resources/cmsresource";

export class DepartmentScheduleIntervalResponse extends CMSResource{
    id: number;
    departmentScheduleId: number;
    intervalStartHour: string; //format HH:mm
    intervalEndHour: string; //format HH:mm
	totalSlots: number;
    availableSlots: number;
    ocupiedSlots: number;
    scheduleDay: string
}